import {
    AppBar,
    Button,
    IconButton,
    MenuItem,
    MenuList,
    Stack,
    ToggleButton,
    ToggleButtonGroup,
    Toolbar,
    Tooltip,
    Typography
} from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import MenuOpenIcon from "@mui/icons-material/MenuOpen"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useLocation, useMatch } from "react-router-dom"
import { AVAILABLE_GAMES } from "../../../constants"
import api from "../../../core/api/base-api"
import { useMenu } from "../../../core/context/menuContext"
import { types as modeTypes } from "../../../core/reducers/mode"
import { keycloak } from "../../../keycloak-config"

const NAV_ITEMS = Object.freeze([
    { to: "/cm", label: "Clockmaker (CM)" },
    { to: "/toh", label: "Train Of Hope (TOH)" },
    { to: "/mc", label: "Color Cube Match (MC)" },
    { to: "/ds", label: "Brilliant Sort (DS)" }
])

const Header = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const authenticated = useSelector((state) => state.data.UserSession.authenticated)
    const isProd = useSelector((state) => state.data.SourceMode.isProd)

    // burger toggles the left nav menu; it exists only on per-game pages (/:game/...)
    const {open: menuOpen, toggle: toggleMenu} = useMenu()
    const gameMatch = useMatch("/:game/*")
    const showMenuToggle = authenticated && AVAILABLE_GAMES.includes(gameMatch?.params?.game)

    const setEnv = (nextIsProd) => {
        if (isProd === nextIsProd) {
            return
        }
        window.localStorage.setItem("isProd", String(nextIsProd))
        dispatch({ type: nextIsProd ? modeTypes.MODE_PROD : modeTypes.MODE_STAGING })
        dispatch(api.util.resetApiState())
    }

    return (
        <AppBar
            position="fixed"
            elevation={0}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                bgcolor: "background.paper",
                color: "text.primary",
                borderBottom: "1px solid",
                borderColor: "divider"
            }}
        >
            <Toolbar
                className={isProd?"toolbarProd":""}
                sx={{ alignItems: "center", justifyContent: "space-between" }}>
                <Stack direction="row" spacing={2} sx={{ alignItems: "center", justifyContent: "center" }}>
                    {showMenuToggle && (
                        <Tooltip title={menuOpen ? "Collapse menu" : "Expand menu"} enterDelay={600}>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label={menuOpen ? "Collapse menu" : "Expand menu"}
                                aria-expanded={menuOpen}
                                onClick={toggleMenu}
                            >
                                {menuOpen ? <MenuOpenIcon/> : <MenuIcon/>}
                            </IconButton>
                        </Tooltip>
                    )}
                    <Typography
                        component={Link}
                        to="/"
                        variant="h5"
                        sx={{ color: "inherit", textDecoration: "none" }}
                    >
                        Hermes
                    </Typography>
                    <ToggleButtonGroup
                        exclusive
                        size="small"
                        color={isProd ? "error" : "standard"}
                        value={isProd ? "prod" : "stage"}
                        onChange={(_, value) => {
                            if (value != null) {
                                setEnv(value === "prod")
                            }
                        }}
                    >
                        <ToggleButton value="prod">Production</ToggleButton>
                        <ToggleButton value="stage">Staging</ToggleButton>
                    </ToggleButtonGroup>
                </Stack>
                {authenticated && (
                    <MenuList>
                        <Stack direction="row" spacing={2}>
                            {NAV_ITEMS.map(({ to, label }) => (
                                <MenuItem
                                    key={to}
                                    component={Link}
                                    to={to}
                                    selected={location.pathname.startsWith(to)}
                                    sx={{ borderRadius: (theme) => theme.shape }}
                                >
                                    {label}
                                </MenuItem>
                            ))}
                        </Stack>
                    </MenuList>
                )}
                {authenticated ? (
                    <Button onClick={keycloak.logout}>
                        Logout
                    </Button>
                ) : (
                    <Button onClick={keycloak.login}>
                        Login
                    </Button>
                )}
            </Toolbar>

        </AppBar>
    )
}

export default Header
